// extracted by mini-css-extract-plugin
export var button = "_gy-4";
export var hasDarkBackground = "_gy-7";
export var hasLightBackground = "_gy-6";
export var iconWrapper = "_gy-0";
export var large = "_gy-2";
export var medium = "_gy-1";
export var small = "_gy-5";
export var xsmall = "_gy-3";